import { render, staticRenderFns } from "./Webinar.vue?vue&type=template&id=4d899c1d&scoped=true&"
import script from "./Webinar.vue?vue&type=script&lang=js&"
export * from "./Webinar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d899c1d",
  null
  
)

export default component.exports